const PRESERVE_KEYS = new Set(["priceList", "mBatch", "alternateUom", "productAddons", "customAttributes", "uomData"]);
// Fashion variant fields: bulkUpsert merges over the stored row, so an empty value
// that is dropped here would leave the old style/size in place. Kept when present;
// only Fashion responses carry them (syncQueries.mapProductToDb).
const KEEP_WHEN_PRESENT = new Set(["parentProductId", "variantAttributes"]);

export function trimProductData(product) {
  const trimmed = {};
  for (const key of Object.keys(product)) {
    const val = product[key];
    if (PRESERVE_KEYS.has(key)) {
      trimmed[key] = val;
      continue;
    }
    if (KEEP_WHEN_PRESENT.has(key)) {
      if (val !== undefined) trimmed[key] = val ?? "";
      continue;
    }
    if (val === null || val === undefined || val === "" || val === "null") continue;
    if (Array.isArray(val) && val.length === 0) continue;
    trimmed[key] = val;
  }
  return trimmed;
}

export function trimProductsBatch(products) {
  return products.map(trimProductData);
}
